var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex",
      on: {
        drag: _vm.preventEvent,
        dragstart: _vm.preventEvent,
        dragend: _vm.preventEvent,
        dragover: _vm.preventEvent,
        dragenter: _vm.preventEvent,
        dragleave: _vm.preventEvent,
        drop: _vm.preventEvent,
      },
    },
    [
      !_vm.disabled && !_vm.image.path
        ? _c("div", { staticClass: "image-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "image-select-wrapper d-flex flex-fill align-items-center justify-content-center",
              },
              [
                _vm.isDragover
                  ? _c(
                      "div",
                      {
                        staticClass: "image-drag-drop-cover",
                        on: { drop: _vm.onDrop },
                      },
                      [
                        _c("div", { staticClass: "icon-drag-drop center" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.assetsPathTheme("/icons/drag-drop.svg"),
                            },
                          }),
                        ]),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "image-drag-wrapper",
                        on: { dragover: _vm.onDragover },
                      },
                      [
                        _c("div", { staticClass: "icon-drag" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.assetsPathTheme("/icons/image.svg"),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "image-input" }, [
                          _c("label", {
                            class: { "cursor-pointer": !_vm.disabled },
                            attrs: { for: _vm.idUpload },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.idUpload == "image-upload-1" &&
                        _vm.showImageLimitMessage
                          ? _c("div", { staticClass: "text-center" }, [
                              _c("p", [
                                _c("span", [_vm._v("Adicionar Images")]),
                                _c("br"),
                                _vm._v(
                                  "\n                        Pode adicionar até " +
                                    _vm._s(_vm.maxImage) +
                                    " image" +
                                    _vm._s(_vm.maxImage == 1 ? "" : "s") +
                                    "\n                    "
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.image.path
        ? _c("div", { staticClass: "image-container" }, [
            _c(
              "div",
              {
                staticClass:
                  "image-preview-wrapper d-flex flex-fill align-items-center justify-content-center cursor-pointer",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "show-image lightbox",
                    class: _vm.imageClass,
                    style: { "background-image": `url(${_vm.image.path})` },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-overlay",
                        class: { "no-overlay": _vm.noOverlay },
                      },
                      [
                        _vm.showEditButton
                          ? _c(
                              "div",
                              {
                                staticClass: "image-overlay-edit",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.triggerFileUpdate()
                                  },
                                },
                              },
                              [_vm._m(0)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showDeleteButton
                          ? _c(
                              "div",
                              {
                                staticClass: "image-overlay-exclude",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.removeImage()
                                  },
                                },
                              },
                              [_vm._m(1)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "image-overlay-details w-100",
                            on: { click: () => _vm.showLightbox() },
                          },
                          [_vm._m(2)]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.image.path && _vm.multiple && false
        ? _c(
            "div",
            { staticClass: "image-list-container d-flex align-items-center" },
            [
              _c(
                "div",
                {
                  staticClass: "image-list-item",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("div", {}, [
                    _c("img", {
                      staticClass: "img-responsive",
                      attrs: { src: _vm.image.path },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "image-list-item" }, [
                _c(
                  "svg",
                  {
                    staticClass: "icon add-image-svg",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "512",
                      height: "512",
                      viewBox: "0 0 512 512",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M511.5 227.5h-227V.5h-57v227H-.5v57h228v228h57v-228h227z",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-add-image" }, [
                  _c("label", { attrs: { for: _vm.idUpload } }),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.disabled
        ? _c("div", { staticClass: "d-none" }, [
            _c("label", { ref: "addImage", attrs: { for: _vm.idUpload } }),
            _vm._v(" "),
            _c("input", {
              ref: "uploadFile",
              attrs: {
                id: _vm.idUpload,
                name: "images",
                type: "file",
                multiple: _vm.multiple,
                accept: _vm.accept,
              },
              on: { change: _vm.uploadFieldChange },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-overlay text-center" }, [
      _c("i", { staticClass: "fas fa-pencil-alt" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-overlay text-center" }, [
      _c("i", { staticClass: "far fa-times-circle" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-overlay text-center" }, [
      _c("i", { staticClass: "fas fa-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }